module.exports = __webpack_public_path__ + "img/svg/wallet.bededb0a80bfa739715c0686a9c6b7cc.svg";